<template lang="pug">
.m-2
  b.pr-2
    | {{ link.numeroTOL }}
  a.doc-link(
    target="_blank"
    :href="url_for_rails_documento_show(link.id)"
    :title="link.title"
  )
    | {{ link.title }}
  div.ml-4(v-if="hasArticles")
    div(v-for="articleNumber in sortedArticles" :key="articleNumber")
      a.art-link(
        target="_blank"
        :href="articleLink(link.id, articleNumber)"
        :title="title(articleNumber)"
      )
        | {{ title(articleNumber) }}
</template>

<script>
import mixins from 'common/mixins'

export default {
  name: 'link-vue',
  props: {
    link: { type: Object, default: () => ({}) }
  },
  mixins: [mixins.translate, mixins.requests],
  computed: {
    hasArticles() {
      return this.link.articles && this.link.articles.length > 0
    },
    sortedArticles() {
      if (!this.hasArticles) return []

      return this.link.articles
        .map(article => parseInt(article))
        .sort((a, b) => a - b)
    }
  },
  methods: {
    articleLink(docId, articleId) {
      let articlePreffix = 'art'
      if (this.is_tolgeo_latam) {
        articlePreffix = 'art_'
      }

      return this.url_for_rails_documento_show(docId, {}, articlePreffix + articleId)
    },
    title(articleId) {
      return this.t('components.link.article') + ' ' + articleId
    }
  }
}
</script>
